<div *sbPageAction>
  <!--
  <sb-button *ngIf="permissionService.hasPermission(permissionService.Permission.time_type_create)"
             [sbRouterLink]="util.RoutingID.timeTypeCreate" classes="btn-success mr-0">
    <sb-icon class="mr-1" icon="plus"></sb-icon>
    {{'lang.globals.timeTypesCreate' | translate}}
  </sb-button>
  -->
</div>

<sb-table-wrapper headline="{{'lang.headlines.timeTypes' | translate}}" [itemsData]="timeTypes"
                  [headerClasses]="['stickyHeader']"
                  [options]="options" (optionsChange)="requestDebounced($event)"
                  [loading]="loading"
                  [itemName]="'timeTypes'" [showExactMatch]="true">
  <ng-template #thead>

    <tr>
      <th>
        {{ 'lang.globals.id' | translate }}
      </th>
      <th>
        {{ 'lang.globals.color' | translate }}
      </th>
      <th>
        {{ 'lang.globals.name' | translate }}
      </th>
      <th>
        {{ 'lang.globals.description' | translate }}
      </th>
      <th>
        {{ 'lang.globals.modifiedAt' | translate }}
      </th>
      <th class="tr">
      </th>
    </tr>
  </ng-template>
  <ng-template #tbody let-timeType>
    <tr>
      <td>
        {{ timeType.id }}
      </td>
      <td>
        <div *ngIf="timeType?.color">
          <span [style.backgroundColor]="'#' + timeType?.color" class="dot mr-1"></span>
          <span [innerHTML]="timeType?.color"></span>
        </div>
        <div *ngIf="!timeType?.color">
          <span class="text-muted">[n.def]</span>
        </div>
      </td>
      <td>
        <span [innerHTML]="timeType.name | truncate: 60"></span>
      </td>
      <td>
        <span [innerHTML]="timeType.description | truncate : 45"></span>
      </td>
      <td>
        <sb-comp-display-modified [data]="timeType"></sb-comp-display-modified>
      </td>
      <td class="tr sticky-col last-col tableBg">
        <!-- missing timetypes
        <a *ngPermissions="[permissionService.Permission.time_type_edit]" ngbTooltip="{{ 'lang.globals.edit' | translate }}"
           placement="left"
           [sbRouterLink]="util.RoutingID.timeTypeEdit" [pathParams]="[{id: 'timeTypeID', value:timeType?.id}]"
           class="btn btn-secondary">
          <sb-icon icon="edit"></sb-icon>
        </a>
        -->
        <!--<a *ngPermissions="[permissionService.Permission.color_definition_delete]"
           ngbTooltip="{{ 'lang.globals.delete' | translate }}" placement="left" (click)="delete(timeType.id)"
           class="btn btn-danger">
          <sb-icon icon="trash"></sb-icon>
        </a>-->
      </td>
    </tr>
  </ng-template>

</sb-table-wrapper>
